import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import LegalPageLayout from "../Components/LegalPageLayout";

function PrivacyCC() {
  return (
    <LegalPageLayout
      titleId="privacy-cc-title"
      icon={faUserShield}
      title="Privacy Policy (Currency Converter)"
      description={
        <p>
          Your privacy is our priority. This page explains how the app handles
          information.
        </p>
      }
    >
            <p className="effective-date">Effective Date: June 18, 2026</p>
            <p>
              Currency Converter is a mobile application developed and operated
              by MileSoft. MileSoft is the data controller for personal
              information processed through Currency Converter. For privacy
              requests, data protection officer (DPO) requests, and controller
              contact purposes, email us at{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              .
            </p>

            <h5>Categories of Personal Data We Collect</h5>
            <p>
              This Privacy Policy applies specifically to MileSoft's Currency
              Converter app. The app may process these categories of data:
            </p>
            <ul>
              <li>
                <strong>Conversion data:</strong> temporary currency codes and
                amounts used to perform a conversion. These inputs are ephemeral
                and are not stored on MileSoft servers.
              </li>
              <li>
                <strong>Device identifiers:</strong> Device ID and other device
                or app identifiers where supplied by platform tooling.
              </li>
              <li>
                <strong>App activity:</strong> interactions needed to understand
                app operation and reliability.
              </li>
              <li>
                <strong>Crash logs and diagnostics:</strong> crash reports,
                error logs, app version, device type, and operating system used
                to diagnose failures and maintain compatibility.
              </li>
            </ul>

            <h5>How We Use Information and Legal Basis</h5>
            <p>
              We use information to perform currency conversions, maintain app
              reliability, respond to support requests, protect against misuse,
              and comply with legal obligations. Our legal basis for processing
              may include performance of a contract or requested service,
              consent, legitimate interests in operating and securing the app,
              legal obligations, and processing requested by you.
            </p>

            <h5>Data Sharing, Sales, and Targeted Advertising</h5>
            <p>
              MileSoft does not sell personal information. We do not share
              conversion inputs with unrelated third parties for their own
              marketing. We may share limited diagnostic or technical
              information with service providers needed to operate the app, when
              required by law, to protect users and systems, or during a
              business transfer.
            </p>
            <p>
              You may opt out of any sale, sharing, or targeted advertising use
              of personal information by emailing{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              . We will honor applicable opt-out rights even though we do not
              sell personal information.
            </p>

            <h5>Security and Encryption</h5>
            <p>
              We use reasonable technical and organizational safeguards,
              including HTTPS and encryption in transit where information is
              sent to our services or service providers. MileSoft does not
              intentionally transmit personal information over unencrypted
              network connections. Conversion inputs are processed temporarily
              and are not stored on MileSoft servers. No security method is
              perfect, and we cannot guarantee absolute security.
            </p>

            <h5>Data Retention</h5>
            <p>
              Conversion inputs are temporary and are not retained on MileSoft
              servers. Diagnostic and technical information, if collected, is
              retained only as long as needed for app reliability, security,
              legal compliance, dispute resolution, backups, or business records.
            </p>

            <h5>Your Privacy Rights</h5>
            <h6>Right to Know About Data Sharing</h6>
            <p>
              You have the right to ask whether MileSoft shares your personal
              information and, where applicable, the categories of personal
              information shared, the purposes for sharing, and the categories
              of recipients. You may make this request using the contact details
              below.
            </p>
            <p>
              Depending on where you live, including under the GDPR, CCPA/CPRA,
              VCDPA, LGPD, and other applicable privacy laws, you may have the
              right to request access to personal information we collect, request
              correction or rectification of inaccurate information, request
              deletion, request a portable copy, object to or restrict certain
              processing, withdraw consent where processing is based on consent,
              and know whether personal information is sold or shared.
            </p>
            <p>
              California residents may exercise CCPA/CPRA rights to know,
              access, correct, delete, and opt out of sale or sharing. Virginia
              residents may exercise VCDPA rights to access, correct, delete,
              obtain a copy, and opt out of targeted advertising, sale, or
              certain profiling. Users in Brazil may exercise LGPD rights,
              including confirmation, access, correction, anonymization,
              deletion, portability, information about sharing, and consent
              withdrawal. Users in the EEA or UK may exercise GDPR rights,
              including access, rectification, erasure, restriction, objection,
              portability, and the right to lodge a complaint with a supervisory
              authority.
            </p>
            <p>
              To make a privacy rights request, contact{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              .
            </p>

            <h5>Changes to This Policy</h5>
            <p>
              MileSoft may update this Privacy Policy from time to time. When we
              update it, we will revise the effective date and may notify users
              through the app, email, or another reasonable method.
            </p>

            <h5>Contact Us</h5>
            <p>
              <strong>Company and App Provider:</strong> MileSoft
              <br />
              <strong>App:</strong> Currency Converter
              <br />
              <strong>Controller and DPO Contact:</strong>{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              <br />
              <strong>Location:</strong> Malawi
            </p>
    </LegalPageLayout>
  );
}

export default PrivacyCC;
